import { render } from "./ProfileAvatarForm.vue?vue&type=template&id=f1573e8a"
import script from "./ProfileAvatarForm.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatarForm.vue?vue&type=script&lang=ts"
script.render = render

export default script